<script setup lang="ts">
import ExperienceEvents from "@/experience/components/ExperienceEvents.vue";
import {computed, reactive} from "vue";
import filters from "../../core/filters";
import ExperienceHeader from "@/experience/components/ExperienceHeader.vue";
import useApodisCoinTransactions from "@/experience/composables/useApodisCoinTransactions";

const params = reactive({
    page: 1,
    limit: 10
});

const {data, isValidating} = useApodisCoinTransactions(params);

const handlePageChange = (page: number) => {
    params.page = page;
};

const handleItemPerPageUpdate = (limit: number) => {
    params.page = 1;
    params.limit = limit;
};

/**
 * Headers used for the data table.
 */
const headers = computed(() => {
    return [
        {
            title: 'Date',
            key: 'created_at',
            sortable: false,
        },
        {
            title: 'Actions',
            key: 'origin',
            sortable: false,
        },
        {
            title: 'Apodis Coins',
            key: 'value',
            sortable: false,
        },
    ];
});
</script>

<template>
  <div>
    <ExperienceHeader />
    <div class="p-4 pb-20">
      <ExperienceEvents />
      <div v-if="data?.data.length" class="py-4">
        <h2>Votre historique</h2>
        <p class="text-primary">
          Félicitations !
        </p>
        <v-data-table-server
          :items-per-page="params.limit"
          :headers="headers"
          :items="data?.data"
          :items-length="data?.meta?.total || 0"
          :loading="isValidating"
          class="my-4"
          @update:items-per-page="handleItemPerPageUpdate"
          @update:page="handlePageChange"
        >
          <template #[`item.created_at`]="{item}">
            <p>{{ filters.date(item.created_at, 'short') }}</p>
          </template>
          <template #[`item.origin`]="{item}">
            <p>{{ item.origin }}</p>
          </template>
          <template #[`item.value`]="{item}">
            <div class="flex flex-row items-center gap-x-2">
              <img
                src="@/assets/images/apodis-coin.png"
                alt="apodis-coin"
                class="w-7 h-7 z-10"
              >
              <span class="text-primary">{{ item.type === 'debit' ? '-' : '+' }}{{ item.value }}</span>
            </div>
          </template>
        </v-data-table-server>
      </div>
    </div>
  </div>
</template>
